import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import Loading from "../../components/common/Loading";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getCategorys, getCompanys, getDepartments, getDesignation, getEmployee, getGroup, getLoan, getLoanType, getLoanwithDaterange, getProfitCenter } from "../../services/dataService";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import "jspdf-autotable";
import FilterComponent from "../pages/FilterComponent";
import { IconFilter } from "@tabler/icons-react";
import toast from "react-hot-toast";

export default function LoanReport() {
  const [data, setData] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [loandata, setloandata] = useState([]);
  const [employeelist, setemployeelist] = useState([]);
  const UID = localStorage.getItem("userId");
  const DepId = localStorage.getItem("DepartmentId");
  const isAdmin = localStorage.getItem('IsAdmin');
  const UserName = localStorage.getItem('UserName');

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [designation, setDesignation] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");


  // const handleDateChange = (e) => {
  //   setDates({
  //     ...dates,
  //     [e.target.name]: e.target.value,
  //   });
  // };


  const [companyDetails, setCompanyDetails] = useState([])
  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0])
      console.log(response.data.data[0], 'Respocsdnse Data');
      
    } catch (error) {
      console.error('An error occurred:', error);
      toast.error('An error occurred while fetching company details');
    }
  };
  
  useEffect(() => {
    fetchCompanyDetails()
  }, [])

  const [selectedMonth, setSelectedMonth] = useState('')

  const handleMonthChange = (e) => {
    const selectedMonth = e.target.value;
    setSelectedMonth(selectedMonth);

    const [year, month] = selectedMonth.split("-");
    const firstDate = new Date(parseInt(year), parseInt(month) - 1, 1);
    const lastDate = new Date(parseInt(year), parseInt(month), 0);

    // Format dates with leading zeros if needed
    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };

    setFromDate(formatDate(firstDate));
    setToDate(formatDate(lastDate));

  };

  const fetchLoanData = async () => {
    try {
      setLoading(true); // Show loading indicator

      const Data = {
        UserId: UID,
        FromDate: fromDate || new Date().toISOString().split('T')[0],
        ToDate: toDate || new Date().toISOString().split('T')[0],
      };

      const response = await getLoanwithDaterange(Data);

      if (response && response.data && response.data.data) {
        console.log(response.data.data?.[0], "Response Data"); // Ensure the data exists
        setloandata(response.data.data); // Update the state with the data
      } else {
        console.warn("No data received in the response");
        setloandata([]); // Set to an empty array if no data
      }
    } catch (error) {
      console.error("Error fetching loan data", error);
    } finally {
      setLoading(false); // Hide loading indicator
    }
  };

  // Use `useEffect` to monitor `loandata` if needed
  useEffect(() => {
    if (loandata.length > 0) {
      console.log(loandata, "Updated Loan Data"); // Verify the state update
    }
  }, [loandata]);



  const [LoanType, setloanType] = useState([])
  useEffect(() => {
    const fetchLoanType = async () => {
      try {
        const response = await getLoanType(UID);
        // const responses = await getDepartments(UID);

        // setDepartment(responses.data.data);
        // console.log(department,"dept");

        setloanType(response.data.data);
        console.log(LoanType, "pro");
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchLoanType();
  }, []);

  const getemployeelist = async () => {
    try {
      const response = await getEmployee(UID);
      setemployeelist(response.data.data);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  useEffect(() => {
    fetchLoanData();
    getemployeelist();
  }, [UID]);



  // Combine loan data with employee names
  useEffect(() => {
    console.log(loandata, 'wwewewew');
    if (loandata && loandata.length > 0) {
      console.log(loandata, 'wwerrrwewew');

      // Correctly find the employee
      const employee = employeelist.find(emp => emp.Id === loandata[0]?.EmployeeId);
      console.log(employee, 'Found Employee');

      // Map the data
      const updatedData = loandata[0]?.map((item, index) => {
        console.log("gffgfgf item", item, "loandata", loandata);
        return {
          Slno: index + 1,
          Id: item.Id || "",
          Name: item.Name || "",
          Branch: item.Branch || "",
          EmployeeName: item?.EmployeeName || "Unknown Employee",
          Number: item.Number || "",
          EmployeeId: item.EmployeeId || "",
          DueDate: item.DueDate || "",
          Amount: item.Amount || "",
          DueAmount: item.DueAmount || "",
          PaymentType: item.PaymentType || "",
          NoofDues: item.NoofDues || "",
          StartDate: item.StartDate || "",
          EndDate: item.EndDate || "",
          UserId: item.UserId || "",
          LoanTypeName: item.LoanTypeName || "",
          LoanType: item.LoanType || "",
          month: item.month || "",
          Year: item.Year || "",
          EmployeeCode: item.EmployeeCode || "",
          DesignationName: item.DesignationName || "Unknown Designation",
        };
      });

      console.log(updatedData, 'gffgfgf');
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [loandata, employeelist]);


  const fetchDesignation = async () => {
    try {
      const response = await getDesignation(UID); // Assuming `getDesignation` is an API call function
      setDesignation(response.data.data);
      console.log(response.data.data, "fetched designations");
    } catch (error) {
      console.error("Error fetching designations:", error);
    }
  };

  useEffect(() => {
    fetchDesignation();
  }, []);

  const columnsFilter = [
    {
      name: "Sl No",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "E_Name",
      selector: (row) => row.EmployeeName || "Unknown",
      sortable: true,
    },
    {
      name: "E_Code",
      selector: (row) => row.EmployeeCode || "Unknown",
      sortable: true,
    },
    {
      name: "E_Designation",
      selector: (row) => row.DesignationName || "Unknown",
      sortable: true,
    },
    {
      name: "Loan Type",
      selector: (row) => {
        const loan = LoanType.find((el) => el.Id === row.LoanType);
        return loan ? loan.Name : "N/A"; // Return "N/A" if no match is found
      },
      sortable: true,
    },
    // {
    //   name: "Loan Name",
    //   selector: (row) => row.Name,
    //   sortable: true,
    // },
    // {
    //   name: "Branch",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan" ? "N/A" : row.Branch || "-";
    //   },
    //   sortable: true,
    // },
    {
      name: "Number",
      selector: (row) => row.Number || "-",
      sortable: true,
    },
    {
      name: "SL_Year",
      selector: (row) => {
        const loan = LoanType.find((el) => el.Id === row.LoanType);
        return loan && loan.Name !== "Society Loan" ? "N/A" : row.Year || "N/A";
      },
      sortable: true,
    },
    {
      name: "SL_ Month",
      selector: (row) => {
        const loan = LoanType.find((el) => el.Id === row.LoanType);
        return loan && loan.Name !== "Society Loan" ? "N/A" : row.month || "N/A";
      },
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => {
        const loan = LoanType.find((el) => el.Id === row.LoanType);
        return loan && loan.Name === "Society Loan" ? row.Amount : row.DueAmount;
      },
      sortable: true,
    },
  
    // {
    //   name: "Due Amount",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan" ? "N/A" : row.DueAmount;
    //   },
    //   sortable: true,
    //   cell: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan"
    //       ? "N/A"
    //       : row.DueAmount
    //         ? `${row.DueAmount.toLocaleString()}`
    //         : "-";
    //   },
    // },
    // {
    //   name: "No. of Dues",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan" ? "N/A" : row.NoofDues;
    //   },
    //   sortable: true,
    // },
    // {
    //   name: "Due Date",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan"
    //       ? "N/A"
    //       : row.DueDate;
    //   },
    //   sortable: true,
    //   cell: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     if (loan && loan.Name === "Society Loan") return "N/A";
    //     if (!row.DueDate) return "-";
    //     const date = new Date(row.DueDate);
    //     return `${date.getDate().toString().padStart(2, "0")}-${(
    //       date.getMonth() + 1
    //     )
    //       .toString()
    //       .padStart(2, "0")}-${date.getFullYear()}`;
    //   },
    // },
    // {
    //   name: "Start Date",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan" ? "N/A" : row.StartDate;
    //   },
    //   sortable: true,
    //   cell: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     if (loan && loan.Name === "Society Loan") return "N/A";
    //     if (!row.StartDate) return "-";
    //     const date = new Date(row.StartDate);
    //     return `${date.getDate().toString().padStart(2, "0")}-${(
    //       date.getMonth() + 1
    //     )
    //       .toString()
    //       .padStart(2, "0")}-${date.getFullYear()}`;
    //   },
    // },
    // {
    //   name: "End Date",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan" ? "N/A" : row.EndDate;
    //   },
    //   sortable: true,
    //   cell: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     if (loan && loan.Name === "Society Loan") return "N/A";
    //     if (!row.EndDate) return "-";
    //     const date = new Date(row.EndDate);
    //     return `${date.getDate().toString().padStart(2, "0")}-${(
    //       date.getMonth() + 1
    //     )
    //       .toString()
    //       .padStart(2, "0")}-${date.getFullYear()}`;
    //   },
    // },
  ];


  const tableRef = useRef();
  const formatDate = (dateString) => {
    if (!dateString || dateString === "N/A") return "N/A";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\//g, '-');
    } catch (e) {
      return dateString;
    }
  };
  const exportToPDF = () => {
    if (!filteredItems || filteredItems.length === 0) {
      console.error("No data available to export.");
      return;
    }
   
    const LoanDatas = filteredItems.filter((el) => {
      if (el.LoanTypeName === 'Society Loan') {
        // For 'Society Loan', check only the Amount
        return el.Amount !== 0 && el.Amount !== "";
      } else {
        // For others, check both Amount and DueAmount
        return el.Amount !== 0 && el.DueAmount !== 0;
      }
    });
    
    console.log(LoanDatas, 'Filtered Loan Data');
    
    
       
    const date = new Date(fromDate);
    const monthNameAndYear = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
    
    const loanTypes = ["Bank Loan", "Society Loan", "LIC"];
  
    // Initialize jsPDF
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    });
  
    // Page dimensions
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margins = { left: 10, right: 10, top: 15, bottom: 20 }; // Increased bottom margin
    const usableWidth = pageWidth - margins.left - margins.right;
  
    // Main title
    const title = `${companyDetails.Name}`;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    const titleWidth = doc.getTextWidth(title);
  
    // Header function - reused for every page
    const addHeader = () => {
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(title, (pageWidth - titleWidth) / 2, margins.top);
      
      // Page number at top right
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text(`Page ${doc.internal.getNumberOfPages()}`, pageWidth - margins.right, margins.top);
    };
  
    // Add header to first page
    addHeader();
  
    // Column width calculations with better distribution
    const calculateColumnWidths = (loanType, availableWidth) => {
      if (loanType == "Society Loan") {
        return {
          0: availableWidth * 0.05,  // S.N - Reduced width
          1: availableWidth * 0.15,  // EmpCode
          2: availableWidth * 0.35,  // Employee Name - Increased
          3: availableWidth * 0.25,  // Designation - Reduced slightly
          4: availableWidth * 0.20   // Amount - Increased slightly
        };
      } else {
        return {
          0: availableWidth * 0.05,  // S.N - Reduced width
          1: availableWidth * 0.12,  // EmpCode - Reduced slightly
          2: availableWidth * 0.30,  // Employee Name - Increased
          3: availableWidth * 0.15,  // Number
          4: availableWidth * 0.23,  // Designation - Reduced slightly
          5: availableWidth * 0.15   // Amount
          // 6: availableWidth * 0.15   // Amount

        };
      }
    };
  
    // Generate column styles
    const generateColumnStyles = (columnWidths) => {
      const styles = {};
      Object.keys(columnWidths).forEach(key => {
        styles[key] = {
          cellWidth: columnWidths[key],
          halign: key === '0' ? 'center' : (key === '4' || key === '5') ? 'right' : 'left',
          valign: 'middle'
        };
      });
      return styles;
    };
  
    // Process each loan type
    let currentY = margins.top + 5; // Increased space after title
    let lastTableY = 0;
  
    loanTypes.forEach((loanType, index) => {
      const loanData = LoanDatas?.filter((row) => row.LoanTypeName === loanType);
  
      if (loanData.length > 0) {
        // Check if we need a new page before starting a new loan type section
        if (index > 0 && currentY > pageHeight / 2) {
          doc.addPage();
          currentY = margins.top + 10;
          addHeader();
        }
        
        // Add subtitle
        const subtitle = `ABTT ${loanType} DEDUCTION DETAILS ON ${monthNameAndYear}`.toUpperCase();
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        const subtitleWidth = doc.getTextWidth(subtitle);
        doc.text(subtitle, (pageWidth - subtitleWidth) / 2, currentY);
        currentY += 6; // Increased space after subtitle
  
        // Prepare table data with proper formatting
        const dataToExport = loanData.map((row, idx) => {
          if (loanType === "Society Loan") {
            return [
              idx + 1,
              row.EmployeeCode || "",
              row.EmployeeName || "",
              row.DesignationName || "",
              row.Amount ? parseFloat(row.Amount).toFixed(2) : "0.00" // Format amount
            ];
          } else {
            return [
              idx + 1,
              row.EmployeeCode || "",
              row.EmployeeName || "",
              row.Number || "",
              row.DesignationName || "",
              row.DueAmount ? parseFloat(row.DueAmount).toFixed(2) : "0.00" // Format amount
            ];
          }
        });
  
        // Calculate grand total
        const grandTotal = loanData.reduce((sum, row) => {
          // Use Amount for Society Loan and DueAmount for other loan types
          const amount = loanType === "Society Loan" ? 
            parseFloat(row.Amount || 0) : 
            parseFloat(row.DueAmount || 0);
          return sum + amount;
        }, 0);
  
        // Add grand total row
        if (loanType === "Society Loan") {
          dataToExport.push([
            "",
            "",
            "",
            "Grand Total:",
            grandTotal.toFixed(2)
          ]);
        } else {
          dataToExport.push([
            "",
            "",
            "",
            "",
            "Grand Total:",
            grandTotal.toFixed(2)
          ]);
        }
  
        // Define headers
        const headers = loanType === "Society Loan" ?
          [["SN", "Employee Code ", "Employee Name", "Designation", "Amount"]] :
          [["SN","Employee Code", "Employee Name", "Policy Number",  "Designation", "Amount"]];
  
        // Generate table
        doc.autoTable({
          head: headers,
          body: dataToExport,
          startY: currentY,
          theme: "grid",
          headStyles: {
            fillColor: [240, 240, 240], // Light gray for better visibility
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.3,
            lineColor: [100, 100, 100], // Darker line for better visibility
            halign: 'center',
            valign: 'middle',
            fontSize: 8 // Slightly larger for better readability
          },
          bodyStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineWidth: 0.2,
            lineColor: [150, 150, 150], // Darker line for better visibility
            fontSize: 7,
            valign: 'middle'
          },
          styles: {
            cellPadding: 2, // Increased padding for better readability
            font: 'helvetica',
            overflow: 'linebreak'
          },
          columnStyles: generateColumnStyles(calculateColumnWidths(loanType, usableWidth)),
          margin: { 
            left: margins.left, 
            right: margins.right, 
            top: currentY, 
            bottom: margins.bottom 
          },
          // Style the grand total row
          didParseCell: (data) => {
            if (data.row.index === dataToExport.length - 1) {
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fillColor = [240, 240, 240]; // Light gray background
              if ((loanType === "Society Loan" && data.column.index === 3) ||
                  (loanType !== "Society Loan" && data.column.index === 4)) {
                data.cell.styles.halign = 'right';
              }
            }
          },
          willDrawCell: (data) => {
            // Format amount columns to align decimals
            if (data.row.section === 'body' && !data.cell.raw === "") {  
              const colIndex = loanType === "Society Loan" ? 4 : 5;
              if (data.column.index === colIndex) {
                data.cell.styles.halign = 'right';
              }
            }
          },
          didDrawPage: (data) => {
            // Add header on each new page
            addHeader();
            
            // Re-add subtitle on new pages if we're inside a table
            if (data.pageCount > 1) {
              const subtitle = `ABTT ${loanType} DEDUCTION DETAILS ON ${monthNameAndYear}`.toUpperCase();
              doc.setFontSize(10);
              doc.setFont("helvetica", "bold");
              const subtitleWidth = doc.getTextWidth(subtitle);
              doc.text(subtitle, (pageWidth - subtitleWidth) / 2, margins.top + 10);
            }
          }
        });
  
        lastTableY = doc.lastAutoTable.finalY;
        currentY = lastTableY + 10; // More space between tables
      }
    });
  
    // Add signature fields at the bottom of the last page only
    doc.setPage(doc.internal.getNumberOfPages()); // Go to last page
    
    const signatureY = pageHeight - margins.bottom - 10; 
    const signatureWidth = usableWidth / 4;
    
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    
    // Clerk
    doc.text("Clerk:", margins.left, signatureY);
    
    // Accounts Officer
    doc.text("Accounts Officer:", margins.left + signatureWidth, signatureY);
    
    // Secretary
    doc.text("Secretary:", margins.left + signatureWidth * 2, signatureY);
    
    // President
    doc.text("President:", margins.left + signatureWidth * 3, signatureY);
  

  // Add generation date to bottom right
  const today = new Date();
  const generatedText = `Generated on: ${today.toLocaleDateString('en-GB')}`;
  const generatedBy = `Generated by: ${UserName}`;

  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0);

  const textWidth = doc.getTextWidth(generatedText);
  const marginRight = 14; // Adjust for padding
  const lineSpacing = 4;  // Adjust for spacing between lines

  // Render the generated text
  doc.text(
    generatedText,
    doc.internal.pageSize.width - textWidth - marginRight,
    doc.internal.pageSize.height - 20
  );

  // Render the generated by text below the generated text
  doc.text(
    generatedBy,
    doc.internal.pageSize.width - textWidth - marginRight,
    doc.internal.pageSize.height - 20 + lineSpacing
  );

    // Save the PDF with an appropriate filename
    const activeLoanTypes = loanTypes.filter(loanType => 
      LoanDatas.some(row => row.LoanTypeName === loanType)
    );
    
    const fileName = activeLoanTypes.length === 1 ?
      `${activeLoanTypes[0].replace(' ', '_')}_${monthNameAndYear.replace(' ', '_')}.pdf` :
      `Loan_Reports_${monthNameAndYear.replace(' ', '_')}.pdf`;
    
    doc.save(fileName);
  };
  //     console.error("No data available to export.");
  //     return;
  //   }
  
  //   const date = new Date(fromDate);
  //   const monthNameAndYear = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
    
  //   const loanTypes = ["Bank Loan", "Society Loan", "LIC"];
  
  //   // Initialize jsPDF
  //   const doc = new jsPDF({
  //     orientation: 'portrait',
  //     unit: 'mm',
  //     format: 'a4'
  //   });
  
  //   // Page dimensions
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const pageHeight = doc.internal.pageSize.getHeight();
  //   const margins = { left: 10, right: 10, top: 15, bottom: 15 };
  //   const usableWidth = pageWidth - margins.left - margins.right;
  
  //   // Add the main title
  //   const title = "ATTUKAL BHAGAVATHY TEMPLE TRUST, THIRUVANANTHAPURAM";
  //   doc.setFontSize(12);
  //   doc.setFont("helvetica", "bold");
  //   const titleWidth = doc.getTextWidth(title);
  //   doc.text(title, (pageWidth - titleWidth) / 2, margins.top);
  
  //   // Column width calculations
  //   const calculateColumnWidths = (loanType, availableWidth) => {
  //     if (loanType === "Society Loan") {
  //       return {
  //         0: availableWidth * 0.07,  // S.N
  //         1: availableWidth * 0.30,  // Employee Name
  //         2: availableWidth * 0.15,  // EmpCode
  //         3: availableWidth * 0.30,  // Designation
  //         4: availableWidth * 0.18   // Amount
  //       };
  //     } else {
  //       return {
  //         0: availableWidth * 0.07,  // S.N
  //         1: availableWidth * 0.15,  // Number
  //         2: availableWidth * 0.25,  // Employee Name
  //         3: availableWidth * 0.13,  // EmpCode
  //         4: availableWidth * 0.25,  // Designation
  //         5: availableWidth * 0.15   // Amount
  //       };
  //     }
  //   };
  
  //   // Generate column styles
  //   const generateColumnStyles = (columnWidths) => {
  //     const styles = {};
  //     Object.keys(columnWidths).forEach(key => {
  //       styles[key] = {
  //         cellWidth: columnWidths[key],
  //         halign: key === '0' ? 'center' : (key === '4' || key === '5') ? 'right' : 'left',
  //         valign: 'middle'
  //       };
  //     });
  //     return styles;
  //   };
  
  //   // Process each loan type
  //   let currentY = margins.top + 8;
  //   let lastTableY = 0;
  
  //   loanTypes.forEach((loanType, index) => {
  //     const loanData = filteredItems?.filter((row) => row.LoanTypeName === loanType);
  
  //     if (loanData.length > 0) {
  //       // Add subtitle
  //       const subtitle = `ABTT  ${loanType} DEDUCTION DETAILS ON ${monthNameAndYear}`.toUpperCase();
  //       doc.setFontSize(10);
  //       doc.setFont("helvetica", "bold");
  //       const subtitleWidth = doc.getTextWidth(subtitle);
  //       doc.text(subtitle, (pageWidth - subtitleWidth) / 2, currentY);
  //       currentY += 5;
  
  //       // Prepare table data with only specified fields
  //       const dataToExport = loanData.map((row, idx) => {
  //         if (loanType === "Society Loan") {
  //           return [
  //             idx + 1,
  //             row.EmployeeName || "",
  //             row.EmployeeCode || "",
  //             row.DesignationName || "",
  //             row.Amount ? parseFloat(row.Amount) : 0
  //           ];
  //         } else {
  //           return [
  //             idx + 1,
  //             row.Number || "",
  //             row.EmployeeName || "",
  //             row.EmployeeCode || "",
  //             row.DesignationName || "",
  //             row.Amount ? parseFloat(row.Amount) : 0
  //           ];
  //         }
  //       });
  
  //       // Calculate grand total
  //       const grandTotal = dataToExport.reduce((sum, row) => {
  //         return sum + (loanType === "Society Loan" ? row[4] : row[5]);
  //       }, 0);
  
  //       // Add grand total row
  //       if (loanType === "Society Loan") {
  //         dataToExport.push([
  //           "",
  //           "",
  //           "",
  //           "Grand Total:",
  //           grandTotal.toFixed(2)
  //         ]);
  //       } else {
  //         dataToExport.push([
  //           "",
  //           "",
  //           "",
  //           "",
  //           "Grand Total:",
  //           grandTotal.toFixed(2)
  //         ]);
  //       }
  
  //       // Define headers
  //       const headers = loanType === "Society Loan" ?
  //         [["S.N", "Employee Name", "EmpCode", "Designation", "Amount"]] :
  //         [["S.N", "Number", "Employee Name", "EmpCode", "Designation", "Amount"]];
  
  //       // Generate table
  //       doc.autoTable({
  //         head: headers,
  //         body: dataToExport,
  //         startY: currentY,
  //         theme: "grid",
  //         headStyles: {
  //           fillColor: [255, 255, 255],
  //           textColor: [0, 0, 0],
  //           fontStyle: "bold",
  //           lineWidth: 0.3,
  //           lineColor: [200, 200, 200],
  //           halign: 'center',
  //           valign: 'middle',
  //           fontSize: 7
  //         },
  //         bodyStyles: {
  //           fillColor: [255, 255, 255],
  //           textColor: [0, 0, 0],
  //           lineWidth: 0.2,
  //           lineColor: [200, 200, 200],
  //           fontSize: 7,
  //           valign: 'middle'
  //         },
  //         styles: {
  //           cellPadding: 1, // Reduced cell padding to decrease row height
  //           font: 'helvetica',
  //           overflow: 'linebreak'
  //         },
  //         columnStyles: generateColumnStyles(calculateColumnWidths(loanType, usableWidth)),
  //         margin: { 
  //           left: margins.left, 
  //           right: margins.right, 
  //           top: currentY, 
  //           bottom: margins.bottom 
  //         },
  //         // Style the grand total row
  //         didParseCell: (data) => {
  //           if (data.row.index === dataToExport.length - 1) {
  //             data.cell.styles.fontStyle = 'bold';
  //             data.cell.styles.fillColor = [255, 255, 255]; // White background for grand total
  //             if (loanType === "Society Loan" && data.column.index === 3) {
  //               data.cell.styles.halign = 'right';
  //             }
  //             if (loanType !== "Society Loan" && data.column.index === 4) {
  //               data.cell.styles.halign = 'right';
  //             }
  //           }
  //         },
  //         didDrawPage: (data) => {
  //           // Page number
  //           doc.setFontSize(8);
  //           doc.text(`Page ${doc.internal.getNumberOfPages()}`, pageWidth - 10, 10);
            
  //           // Re-add title on new pages
  //           if (doc.internal.getNumberOfPages() > 1) {
  //             doc.setFontSize(12);
  //             doc.setFont("helvetica", "bold");
  //             doc.text(title, (pageWidth - titleWidth) / 2, margins.top);
              
  //             // Re-add subtitle
  //             doc.setFontSize(10);
  //             doc.text(subtitle, (pageWidth - subtitleWidth) / 2, margins.top + 8);
  //           }
  //         }
  //       });
  
  //       lastTableY = doc.lastAutoTable.finalY;
  //       currentY = lastTableY + 5;
  
  //       // Add page break if needed
  //       if (index < loanTypes.length - 1 && currentY + 30 > pageHeight - margins.bottom) {
  //         doc.addPage();
  //         currentY = margins.top + 8;
  //       }
  //     }
  //   });
  
  //   // Add signature fields at the bottom of the last page
  //   if (lastTableY + 30 < pageHeight - margins.bottom) {
  //     const signatureY = pageHeight - margins.bottom - 20;
  //     const signatureWidth = usableWidth / 4;
      
  //     doc.setFontSize(8);
  //     doc.setFont("helvetica", "normal");
      
  //     // Clerk
  //     doc.text("Clerk:", margins.left, signatureY);
  //     // doc.line(margins.left, signatureY + 2, margins.left + signatureWidth - 10, signatureY + 2);
      
  //     // Accounts Officer
  //     doc.text("Accounts Officer:", margins.left + signatureWidth, signatureY);
  //     // doc.line(margins.left + signatureWidth, signatureY + 2, margins.left + signatureWidth * 2 - 10, signatureY + 2);
      
  //     // Secretary
  //     doc.text("Secretary:", margins.left + signatureWidth * 2, signatureY);
  //     // doc.line(margins.left + signatureWidth * 2, signatureY + 2, margins.left + signatureWidth * 3 - 10, signatureY + 2);
      
  //     // President
  //     doc.text("President:", margins.left + signatureWidth * 3, signatureY);
  //     // doc.line(margins.left + signatureWidth * 3, signatureY + 2, margins.left + signatureWidth * 4 - 10, signatureY + 2);
  //   }
  
  //   // Save the PDF
  //   const activeLoanTypes = loanTypes.filter(loanType => 
  //     filteredItems.some(row => row.LoanTypeName === loanType)
  //   );
    
  //   const fileName = activeLoanTypes.length === 1 ?
  //     `${activeLoanTypes[0]}_${monthNameAndYear.replace(' ', '_')}.pdf` :
  //     `LoanReports_${monthNameAndYear.replace(' ', '_')}.pdf`;
    
  //   doc.save(fileName);
  // };
  // Helper function to calculate proportion al column widths
  function calculateColumnWidths(loanType, availableWidth) {
    if (loanType === "Society Loan") {
      // Relative proportions for Society Loan columns
      const proportions = [0.05, 0.22, 0.18, 0.1, 0.1, 0.15, 0.2];
      return proportions.map(p => p * availableWidth);
    } else {
      // Relative proportions for Bank/LIC Loan columns
      const proportions = [0.04, 0.15, 0.13, 0.08, 0.08, 0.08, 0.09, 0.09, 0.06, 0.1, 0.1];
      return proportions.map(p => p * availableWidth);
    }
  }

  // Helper function to generate column styles based on calculated widths
  function generateColumnStyles(loanType, columnWidths) {
    const styles = {};

    columnWidths.forEach((width, index) => {
      styles[index] = {
        cellWidth: width,
        halign: getColumnAlignment(loanType, index)
      };
    });

    return styles;
  }

  // Helper function to determine text alignment for each column
  function getColumnAlignment(loanType, columnIndex) {
    if (columnIndex === 0) return 'center'; // S.N

    if (loanType === "Society Loan") {
      if (columnIndex === 5) return 'right'; // Amount
      return (columnIndex === 3 || columnIndex === 4) ? 'center' : 'left';
    } else {
      // For Bank/LIC Loan
      if (columnIndex >= 3 && columnIndex <= 5) return 'center'; // Dates
      if (columnIndex === 6 || columnIndex === 7) return 'right'; // Amounts
      if (columnIndex === 8) return 'center'; // No. of Dues
      return 'left';
    }
  }
  const exportToExcel = () => {
    if (!filteredItems || filteredItems.length === 0) {
      console.error("No data available to export.");
      return;
    }
  
    const date = new Date(fromDate);
    const monthNameAndYear = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
  
    // Define loan types
    const loanTypes = ["Bank Loan", "Society Loan", "LIC"];
  
    // Create a new workbook
    const wb = XLSX.utils.book_new();
  
    // Helper function to format date (matches PDF format)
    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };
  
    // Process each loan type
    loanTypes.forEach((loanType) => {
      const loanData = filteredItems.filter((row) => row.LoanTypeName === loanType);
  
      if (loanData.length > 0) {
        // Create worksheet data array
        const wsData = [];
  
        // Add title (matches PDF)
        wsData.push([`${companyDetails.Name}`]);
        wsData.push([]); // Empty row
  
        // Add subtitle with date (matches PDF)
        wsData.push([`${loanType} Statement ON ${monthNameAndYear}`]);
        wsData.push([]); // Empty row
  
        // Create headers based on loan type (matches PDF fields)
        const headers = loanType === "Society Loan" ?
          ["S.N", "EmployeeCode", "Employee Name", "Designation", "Amount"] :
          ["S.N", "Number", "EmployeeCode", "Employee Name", "Designation", "DueAmount"];
  
        wsData.push(headers);
  
        // Add data rows
        loanData.forEach((row, idx) => {
          if (loanType === "Society Loan") {
            wsData.push([
              idx + 1,
              row.EmployeeCode || "",
              row.EmployeeName || "",
              row.DesignationName || "",
              row.Amount ? parseFloat(row.Amount).toFixed(2) : "0.00"
            ]);
          } else {
            wsData.push([
              idx + 1,
              row.Number || "",
              row.EmployeeCode || "",
              row.EmployeeName || "",
              row.DesignationName || "",
              row.DueAmount ? parseFloat(row.DueAmount).toFixed(2) : "0.00"
            ]);
          }
        });
  
        // Add grand total row
        const grandTotal = loanData?.reduce((sum, row) => {
          const value = loanType === "Society Loan" 
            ? parseFloat(row.Amount || 0) 
            : parseFloat(row.DueAmount || 0);
          return sum + value;
        }, 0);
        
        if (loanType === "Society Loan") {
          wsData.push(["", "", "", "Grand Total:", grandTotal.toFixed(2)]);
        } else {
          wsData.push(["", "", "", "", "Grand Total:", grandTotal.toFixed(2)]);
        }
        
        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(wsData);
  
        // Set column widths
        const colWidths = loanType === "Society Loan" ?
          [{ wch: 5 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 10 }] :
          [{ wch: 5 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 10 }];
        ws['!cols'] = colWidths;
  
        // Merge title and subtitle cells
        ws['!merges'] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }, // Title
          { s: { r: 2, c: 0 }, e: { r: 2, c: headers.length - 1 } }  // Subtitle
        ];
  
        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, loanType);
      }
    });
  
    // Generate file name
    const activeLoanTypes = loanTypes.filter((loanType) =>
      filteredItems.some(row => row.LoanTypeName === loanType)
    );
  
    const fileName = activeLoanTypes.length === 1 ?
      `${activeLoanTypes[0]}_${monthNameAndYear.replace(' ', '_')}.xlsx` :
      `LoanReports_${monthNameAndYear.replace(' ', '_')}.xlsx`;
  
    // Write the workbook to file
    XLSX.writeFile(wb, fileName);
  };
  

  const filteredItems = dataFilter?.filter((item) => {
    return (
      (item.EmployeeName?.toLowerCase().includes(filterText.toLowerCase())) ||
      // (item.Name?.toLowerCase().includes(filterText.toLowerCase())) ||
      // (item.Branch?.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.Number?.toString().toLowerCase().includes(filterText.toLowerCase())) || 
      (item.EmployeeCode?.toString().toLowerCase().includes(filterText.toLowerCase()))||
      (item.DesignationName?.toString().toLowerCase().includes(filterText.toLowerCase()))


      

    );
  });

  
  // useEffect(() => {
  //   setDataFilter(loandata)
  // }, [loandata]);
  


  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };


  const [category, setCategory] = useState([])
  const [group, setGroup] = useState([])
  const [Department, setDepartment] = useState([])
  const [FilterProfitcenter, setFilterProfitcenter] = useState([])
  const [filterMethod, setFilterMethod] = useState("")
  const [dropdownOptions, setDropdownOptions] = useState([]);

  useEffect(() => {
    const fetchcategory = async () => {
      try {
        const response = await getCategorys(UID);


        setCategory(response);
        console.log(category, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchcategory();
  }, []);


  useEffect(() => {
    const fetchdesignation = async () => {
      try {
        const response = await getDesignation(UID)

        setDesignation(response);
        console.log(designation, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchdesignation();
  }, []);



  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await getGroup(UID);



        setGroup(response);
        console.log(group, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchGroup();
  }, []);


  useEffect(() => {
    // Set the initial month to the current month
    const currentDate = new Date();
    const currentMonth = currentDate.toISOString().slice(0, 7); // Format: YYYY-MM
    setSelectedMonth(currentMonth);

    // Calculate and set the default fromDate and toDate
    const firstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };

    setFromDate(formatDate(firstDate));
    setToDate(formatDate(lastDate));
  }, []);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);



        setDepartment(response);
        console.log(Department, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchDepartment();
  }, []);



  useEffect(() => {
    const fetchfilterProfitecenter = async () => {
      try {
        const response = await getProfitCenter(UID);
        setFilterProfitcenter(response);
        console.log(response, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    fetchfilterProfitecenter();
  }, [UID]); // Add UID here if it can change

  useEffect(() => {
    const dataMapping = {
      CategoryId: category?.data?.data,
      ProfitCenterID: FilterProfitcenter?.data?.data,
      GroupId: group?.data?.data,
      DesignationId: designation?.data?.data,
      DepartmentID: Department?.data?.data,
    };

    setDropdownOptions(dataMapping[filterMethod] || []);
  }, [filterMethod, category, FilterProfitcenter, group, designation, Department]);




  useEffect(() => {
    console.log('sdas', "elect an Opti", filterMethod)
  },)

  const handleFilterChange = async (selectedMethod, Name, Id) => {
    setFilterMethod(selectedMethod);

    const requestData = {
      UserId: UID,
      name: selectedMethod, // Use the selected filter method here
      Id,                   // Use the selected option's Id
      FromDate: fromDate|| new Date().toISOString().split("T")[0], // Include FromDate
      ToDate: toDate || new Date().toISOString().split("T")[0],     // Include ToDate
    };

    console.log("Request Data:", requestData);


    try {
      setLoading(true);
      const response = await getLoanwithDaterange(requestData);

      if (response && response.data && response.data.data) {
        console.log(response.data.data?.[0], "Response Data"); // Ensure the data exists
        setloandata(response.data.data); // Update the state with the data
      } else {
        console.warn("No data received in the response");
        setloandata([]); // Set to an empty array if no data
      }
    } catch (error) {
      console.error("Error fetching loan data", error);
    } finally {
      setLoading(false); // Hide loading indicator
    }
  };

  return (
    <>
      <div className="w-full">
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-8">
          {/* Left Section: Breadcrumb */}
          <div className="flex items-center gap-4">
            <Breadcrumb title="Loan Report" />
          </div>

          {/* Right Section: All Controls (becomes stacked on mobile) */}
          <div className="flex flex-col md:flex-row gap-4 w-full lg:w-auto">
            {/* Search and Filter Bar */}
            <div className="flex flex-wrap items-center gap-2 p-3 md:p-4 bg-gray-100 rounded w-full md:w-auto">
              <button
                className="bg-sky rounded-[4px] px-4 md:px-10 py-[8px]"
                onClick={handleFilterClick}
              >
                <IconFilter className="text-white w-[18px] h-[18px]" />
              </button>
              <div className="flex-grow">
                <input
                  type="text"
                  id="search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                  placeholder="Search by Name/Code/Loan Number/Designation"
                  className="w-[350px] px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
              </div>
              <button onClick={handleClear} className="btn btn-danger whitespace-nowrap">
                Clear
              </button>
            </div>

            {/* Export Buttons */}
            <div className="flex items-center gap-2">
              <button onClick={exportToExcel} className="bg-green-500 text-white rounded-md px-4 py-2 hover:bg-green-600 transition-colors flex-1 text-center">
                Excel
              </button>
              <button onClick={exportToPDF} className="bg-red-500 text-white rounded-md px-4 py-2 hover:bg-red-600 transition-colors flex-1 text-center">
                PDF
              </button>
            </div>
          </div>
        </div>

        {/* Date Range and Filter Section - Separate row on all screens */}
        <div className="flex flex-col md:flex-row flex-wrap gap-4 mb-6">
          {/* Date Range Controls */}
          <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
            {/* <div className="flex items-center gap-2">
              <label htmlFor="from-date-input" className="text-sm font-medium text-gray-700 whitespace-nowrap">
                From
              </label>
              <input
                type="date"
                name="FromDate"
                onChange={handleDateChange}
                value={dates.FromDate || new Date().toISOString().split('T')[0]}
                id="from-date-input"
                className="px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600 w-full"
              />
            </div> */}

            <div className="flex flex-col">
              <label htmlFor="choose-month" className="font-medium mb-1">
                Choose Month:
              </label>
              <input
                type="month"
                id="choose-month"
                className="border rounded p-2 w-[200px]"
                value={selectedMonth}
                onChange={handleMonthChange}
              />
            </div>

            {/* <div className="flex items-center gap-2">
        <label htmlFor="to-date-input" className="text-sm font-medium text-gray-700 whitespace-nowrap">
          To
        </label>
        <input
          type="date"
          name="ToDate"
          onChange={handleDateChange}
          value={dates?.ToDate || new Date().toISOString().split('T')[0]}
          id="to-date-input"
          className="px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600 w-full"
        />
      </div> */}

            <button className="btn btn-primary whitespace-nowrap mt-4" onClick={fetchLoanData}>
              Show
            </button>
          </div>

          {/* Filter Dropdowns */}
          <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
            <select
              id="filter-method"
              name="filter-method"
              className="px-3 py-2 border border-gray-400 mt-3 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600 w-full sm:w-auto"
              value={filterMethod}
              onChange={(e) => setFilterMethod(e.target.value)}
            >
              <option value="">Filter By</option>
              <option value="CategoryId">Category</option>
              <option value="ProfitCenterID">Profit Center</option>
              <option value="GroupId">Group</option>
              <option value="DesignationId">Designation</option>
              <option value="DepartmentID">Department</option>
            </select>

            <select
              id="dynamic-options"
              name="dynamic-options"
              className="px-3 py-2 border border-gray-400 mt-3 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600 w-full sm:w-auto"
              onChange={(e) => {
                const selectedOption = dropdownOptions.find(
                  (option) => option.Id.toString() === e.target.value
                );
                if (selectedOption) {
                  handleFilterChange(
                    filterMethod,
                    selectedOption.FromDate,
                    selectedOption.Id,
                    selectedOption.ToDate,
                    filterMethod
                  );
                }
              }}
            >
              <option value="">Choose One</option>
              {dropdownOptions.length > 0 &&
                dropdownOptions.map((option) => (
                  <option key={option.Id} value={option.Id}>
                    {option.Name}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>

      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={loandata[0]} onFilter={handleFilter} />
      )}

      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <div ref={tableRef}>
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems?.length ? filteredItems : []}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                persistTableHead
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}